import SystemConfig, {CONFIG_PARAMS} from "../system/SystemConfig";
import {GAME_EVENTS} from "./gameEvents";
import events from "../events/EventsObservable";
import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import ISymbols from "../engine/pixi/ISymbols";
import IGameCore from "./IGameCore";
import Slots from "./slot/Slots";
import ISlots from "./slot/ISlots";

@injectable()
class GameSlotsCore implements IGameCore {

    protected config: SystemConfig;
    protected gameset: any;
    public slots: ISlots;

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.EngineAppSymbols) symbols: ISymbols
    ) {

        this.config = config;
        this.gameset = config.gameset;

		this.createSlots(symbols);
    }

    createSlots(symbols: ISymbols) {
        let columns = this.gameset['game']['symbolModel']['baseMatrix']['x'].length;

        this.slots = new Slots(this.config, columns, symbols);
    }

    create() {
        let reelMatrix = this.config.get(CONFIG_PARAMS.START_MATRIX);
        this.slots.create(reelMatrix);
    }

    forcestop() {
        this.slots.forceStop();
    }

    async start() {

        events.dispatch(GAME_EVENTS.GAME_SPIN_START);

        return this.slots.spin().then(() => {
            events.dispatch(GAME_EVENTS.GAME_SPIN_END);
        });

    }

    async stop(addResult, resultIndex = 0) {

        this.slots.setResult(addResult.getReelMatrix()[resultIndex]);

        let symbolsMatrix = this.slots.getResultSymbolsMatrix();

        await events.dispatch(GAME_EVENTS.GAME_ADD_RESULT, { addResult, symbolsMatrix });
        this.slots.stop();
    }

    stopFreespins(addResult) {
        this.stop(addResult);
    }

    async stopFail(failResult) {

        await events.dispatch(GAME_EVENTS.GAME_ADD_FAIL_RESULT, failResult);

        this.slots.setResult(failResult.getFailMatrix());
        this.slots.stop();
    }
}

export default GameSlotsCore;
